import { MutationTree } from 'vuex'
import { mutationType } from './mutation-types'
import { ILocation, MapState } from './states'
import _ from 'lodash'
const mutations: MutationTree<MapState> = {
  [mutationType.SET_USER_LOCATION](
    state: MapState,
    data: ILocation,
  ): void {
    state.user = data
  },
  [mutationType.SET_PATIENT_LOCATION](
    state: MapState,
    userId: ILocation,
  ): void {
    state.patient = userId
  },
}

export default mutations
